<div>
  <div class="tw-flex tw-items-center tw-justify-between tw-px-5">
    <div class="tw-font-bold tw-text-500 tw-normal-case" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
        {{ sectionName }}
    </div>
    @if (isShopRevampExperimentOn) {
      <cs-icon class="tw-w-6 tw-h-6 tw-text-teal-500" [iconName]="'chevron_right'" (click)="viewAll(viewAllSection)" />
    } @else {
      <div class="tw-font-body tw-text-300 tw-text-gray-700 tw-normal-case" (click)="viewAll(viewAllSection)">
        <span i18n="@@viewAll">View all</span><em class="cs-icon-arrow"></em>
      </div>
    }
  </div>
</div>